// Which requests wait for the AWS WAF token and carry its cookie: the Blazor app's WafTokenGate and
// WafTokenCredentialsHandler. The token itself is acquired by the bootstrap in index.html, which exposes
// window.lifyWafReady; with no WAF configured (dev, a local run) that answers at once.

/**
 * The site this page belongs to, which our API hosts sit under: the page's host without its first label
 * (identity.lifyapp.com gives lifyapp.com, identity.branch.healthpassport.pro gives branch.healthpassport.pro),
 * or the host itself when it has only two. Null for a host with no dot or an IP address, such as localhost.
 */
function siteDomain(host: string): string | null {
    if (!host || /^[\d.]+$/.test(host) || host.includes(':')) return null;

    const labels = host.split('.');

    if (labels.length < 2) return null;
    if (labels.length === 2) return host;

    return labels.slice(1).join('.');
}

const site = siteDomain(location.hostname);

/**
 * A request to our own API: it waits for a live token and goes out with credentials, so the aws-waf-token cookie
 * travels with it across origins. Anything else — ipinfo, storage — carries none of our cookies.
 * @param {string} url
 */
export function goesToOurApi(url: string): boolean {
    let host: string;

    try {
        host = new URL(url, location.href).hostname;
    } catch {
        return false;
    }

    if (host === 'localhost') return true;

    return !!site && (host === site || host.endsWith('.' + site));
}

/** Completes when a live token is in the cookie, or when the bootstrap's deadline passes. Never rejects. */
export async function wafReady(): Promise<void> {
    if (typeof window.lifyWafReady !== 'function') return;

    try {
        await window.lifyWafReady();
    } catch {
        // No token to be had: the request goes out without one, as it would have anyway.
    }
}
